import { checkAndGetLatestOutputFields } from '../program-wizard/common/output-layout-utils';
import {
  AnyRecord,
  ProgramDataType,
  ssarPreSubmitValidator,
  SSARProgram,
  SSARProgramStatus,
} from '@ssar-app/domain';

export const ProgramConverter = {
  toServerProgramModel: (
    ssarProgramData: SSARProgram,
    ssarProgramStatus?: SSARProgramStatus,
    clonedFrom?: Partial<SSARProgram> | null | undefined,
  ): Partial<SSARProgram> => {
    if (clonedFrom && clonedFrom.metadata) {
      return {
        subCode: ssarProgramData.subCode,
        status: ssarProgramStatus,
        programKey: ssarProgramData.programKey,
        orderDetails: ssarProgramData.orderDetails,
        attributesAndBundles: ssarProgramData.attributesAndBundles,
        demographics: ssarProgramData.demographics,
        inputFile: ssarProgramData.inputFile,
        outputLocations: ssarProgramData.outputLocations,
        scoresAndAddonProducts: ssarProgramData.scoresAndAddonProducts,
        outputLayout: ssarProgramData.outputLayout,
        metadata: clonedFrom.metadata,
      };
    } else {
      return {
        subCode: ssarProgramData.subCode,
        status: ssarProgramStatus,
        programKey: ssarProgramData.programKey,
        orderDetails: ssarProgramData.orderDetails,
        attributesAndBundles: ssarProgramData.attributesAndBundles,
        demographics: ssarProgramData.demographics,
        inputFile: ssarProgramData.inputFile,
        outputLocations: ssarProgramData.outputLocations,
        scoresAndAddonProducts: ssarProgramData.scoresAndAddonProducts,
        outputLayout: ssarProgramData.outputLayout,
      };
    }
  },
};

export const validateProgramData = async (
  data: ProgramDataType,
  metaData?: AnyRecord,
  setMetaData?: (metaData: AnyRecord) => void,
): Promise<SSARProgram> => {
  const programData = data as SSARProgram;
  return await ssarPreSubmitValidator
    .validate(programData)
    .then(async () => {
      const outputLayoutData = await checkAndGetLatestOutputFields(
        programData,
        metaData?.prevData as SSARProgram,
      );
      const outputLayout = {
        ...programData.outputLayout,
        ...outputLayoutData,
      };
      programData.outputLayout = outputLayout;

      setMetaData?.({
        ...metaData,
        prevData: { ...programData, outputLayout: outputLayout },
        outputLayout: outputLayout,
      });
      return programData;
    })
    .catch((err) => {
      throw new Error(err);
    });
};
